import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getDailyDeal, getFeaturedPet, getEvents } from "../lib/api";
import { fmtEventDate, fmtEventTime } from "../lib/eventFormat";
import { Flame, Heart, PawPrint, CalendarDays, MapPin, Star } from "lucide-react";

export function DailyDeal() {
  const [deal, setDeal] = useState(null);
  useEffect(() => { getDailyDeal().then((d) => setDeal(d && d.title ? d : null)).catch(() => {}); }, []);
  if (!deal) return null;
  return (
    <div data-testid="daily-deal-widget" className="overflow-hidden rounded-xl border border-[var(--paper-border)] bg-white">
      <div className="flex items-center gap-2 bg-[var(--breaking)] px-4 py-2 text-white">
        <Flame size={16} /> <span className="font-ui text-xs font-bold uppercase tracking-wider">Local Daily Deal</span>
      </div>
      {deal.image && <div className="img-zoom h-36 overflow-hidden"><img src={deal.image} alt={deal.title} className="h-full w-full object-cover" /></div>}
      <div className="p-4">
        <p className="eyebrow text-[var(--gold)]">{deal.business}</p>
        <div className="flex items-baseline justify-between">
          <h4 className="font-display text-lg font-bold text-[var(--navy)]">{deal.title}</h4>
          {deal.discount && <span className="font-display text-xl font-extrabold text-[var(--breaking)]">{deal.discount}</span>}
        </div>
        <p className="font-serif-body mt-1 text-sm text-slate-600">{deal.description}</p>
      </div>
    </div>
  );
}

export function PetOfWeek() {  const [pet, setPet] = useState(null);
  useEffect(() => { getFeaturedPet().then((p) => setPet(p && p.name ? p : null)).catch(() => {}); }, []);
  if (!pet) return null;
  return (
    <Link to="/pets" data-testid="pet-of-week-widget" className="card-hover block overflow-hidden rounded-xl border border-[var(--paper-border)] bg-white">
      <div className="flex items-center gap-2 bg-[var(--gold)] px-4 py-2 text-white">
        <PawPrint size={16} /> <span className="font-ui text-xs font-bold uppercase tracking-wider">Pet of the Week</span>
      </div>
      <div className="img-zoom h-44 overflow-hidden"><img src={pet.image} alt={pet.name} className="h-full w-full object-cover object-top" /></div>
      <div className="p-4">
        <h4 className="font-display text-xl font-bold text-[var(--navy)]">{pet.name}</h4>
        <p className="font-ui text-xs text-slate-500">{pet.breed} · {pet.age} · {pet.rescue}</p>
        <p className="font-serif-body mt-1 line-clamp-2 text-sm text-slate-600">{pet.description}</p>
        <span className="font-ui mt-2 inline-flex items-center gap-1 text-xs font-semibold uppercase tracking-wider text-[var(--gold)]"><Heart size={11} /> Meet all adoptable pets →</span>
      </div>
    </Link>
  );
}

export function UpcomingEvents() {
  const [events, setEvents] = useState([]);
  useEffect(() => { getEvents().then((e) => setEvents(e.slice(0, 4))).catch(() => {}); }, []);
  if (events.length === 0) return null;
  return (
    <div data-testid="upcoming-events-widget" className="overflow-hidden rounded-xl border border-[var(--paper-border)] bg-white">
      <div className="flex items-center justify-between bg-[var(--navy)] px-4 py-2 text-white">
        <span className="font-ui flex items-center gap-2 text-xs font-bold uppercase tracking-wider"><CalendarDays size={16} className="text-[var(--gold)]" /> Upcoming Events</span>
      </div>
      <div className="divide-y divide-slate-100">
        {events.map((e) => (
          <Link key={e.id} to="/events" data-testid={`event-widget-${e.id}`} className="block px-4 py-3 hover:bg-slate-50">
            <p className="font-ui flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-wide text-[var(--gold)]">
              {e.sponsored && <Star size={11} className="fill-[var(--gold)]" />} {fmtEventDate(e.start)}{fmtEventTime(e.start) && ` · ${fmtEventTime(e.start)}`}
            </p>
            <p className="font-display text-sm font-bold text-[var(--navy)] line-clamp-1">{e.title}</p>
            {e.location && <p className="font-ui flex items-center gap-1 text-[11px] text-slate-500"><MapPin size={11} /> {e.location}</p>}
          </Link>
        ))}
      </div>
      <Link to="/events" className="block border-t border-slate-100 px-4 py-2.5 text-center font-ui text-xs font-semibold uppercase tracking-wider text-[var(--navy)] hover:bg-slate-50">
        View full calendar →
      </Link>
    </div>
  );
}
